import { render, staticRenderFns } from "./ListContanctProviderComponent.vue?vue&type=template&id=4c0fb15b"
import script from "./ListContanctProviderComponent.vue?vue&type=script&lang=js"
export * from "./ListContanctProviderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports